import React from 'react';

const TimelineEmptyIcon: React.FC<{ isNotBg?: boolean }> = ({ isNotBg }) =>
  isNotBg ? (
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        fill="white"
      />
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        stroke="#D2D6DB"
      />
      <g filter="url(#filter0_i_34826_92990)">
        <rect x="1.9834" y="14.9277" width="52" height="52" rx="14" fill="white" />
        <rect x="2.4834" y="15.4277" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9834 26.5947C16.5357 26.5947 16.9834 27.0424 16.9834 27.5947L16.9834 54.2614C16.9834 54.8137 16.5357 55.2614 15.9834 55.2614C15.4311 55.2614 14.9834 54.8137 14.9834 54.2614L14.9834 27.5947C14.9834 27.0424 15.4311 26.5947 15.9834 26.5947Z"
          fill="#00A389"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.65 49.5947C31.65 47.9379 30.3069 46.5947 28.65 46.5947H14.9834V53.9281H28.65C30.3069 53.9281 31.65 52.5849 31.65 50.9281V49.5947Z"
          fill="#00A389"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.9834 40.2607C40.9834 38.6039 39.6403 37.2607 37.9834 37.2607L14.9834 37.2607V44.5941L37.9834 44.5941C39.6403 44.5941 40.9834 43.2509 40.9834 41.5941V40.2607Z"
          fill="#00A389"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9834 30.9277C28.9834 29.2709 27.6403 27.9277 25.9834 27.9277L14.9834 27.9277L14.9834 35.2611H25.9834C27.6403 35.2611 28.9834 33.9179 28.9834 32.2611V30.9277Z"
          fill="#00A389"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_34826_92990"
          x="1.9834"
          y="12.0277"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_92990" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width="203" height="173" viewBox="0 0 203 173" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_34826_92467)">
        <line x1="10.5" y1="-4" x2="10.5" y2="178" stroke="#E5E7EB" />
        <line x1="28.5" y1="-4" x2="28.5" y2="178" stroke="#E5E7EB" />
        <line x1="46.5" y1="-4" x2="46.5" y2="178" stroke="#E5E7EB" />
        <line x1="64.5" y1="-4" x2="64.5" y2="178" stroke="#E5E7EB" />
        <line x1="82.5" y1="-4" x2="82.5" y2="178" stroke="#E5E7EB" />
        <line x1="100.5" y1="-4" x2="100.5" y2="178" stroke="#E5E7EB" />
        <line x1="118.5" y1="-4" x2="118.5" y2="178" stroke="#E5E7EB" />
        <line x1="136.5" y1="-4" x2="136.5" y2="178" stroke="#E5E7EB" />
        <line x1="154.5" y1="-4" x2="154.5" y2="178" stroke="#E5E7EB" />
        <line x1="172.5" y1="-4" x2="172.5" y2="178" stroke="#E5E7EB" />
        <line x1="190.5" y1="-4" x2="190.5" y2="178" stroke="#E5E7EB" />
        <line x1="242.688" y1="16.5908" x2="-42.8176" y2="14.5003" stroke="#E5E7EB" />
        <line x1="242.556" y1="34.5898" x2="-42.9494" y2="32.4994" stroke="#E5E7EB" />
        <line x1="242.424" y1="52.5898" x2="-43.081" y2="50.4994" stroke="#E5E7EB" />
        <line x1="242.292" y1="70.5889" x2="-43.2129" y2="68.4984" stroke="#E5E7EB" />
        <line x1="242.16" y1="88.5889" x2="-43.3447" y2="86.4984" stroke="#E5E7EB" />
        <line x1="242.029" y1="106.588" x2="-43.4765" y2="104.497" stroke="#E5E7EB" />
        <line x1="241.897" y1="124.588" x2="-43.6084" y2="122.497" stroke="#E5E7EB" />
        <line x1="241.765" y1="142.587" x2="-43.7402" y2="140.496" stroke="#E5E7EB" />
        <line x1="241.633" y1="160.587" x2="-43.8718" y2="158.496" stroke="#E5E7EB" />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          fill="white"
        />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          stroke="#D2D6DB"
        />
        <g filter="url(#filter0_i_34826_92467)">
          <rect x="79.5" y="69.9443" width="52" height="52" rx="14" fill="white" />
          <rect x="80" y="70.4443" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
          <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M93.5001 84.6113C94.2365 84.6113 94.8334 85.2083 94.8334 85.9447V103.278C94.8334 105.119 96.3258 106.611 98.1667 106.611H117.5C118.236 106.611 118.833 107.208 118.833 107.945C118.833 108.681 118.236 109.278 117.5 109.278H98.1667C94.853 109.278 92.1667 106.592 92.1667 103.278V85.9447C92.1667 85.2083 92.7637 84.6113 93.5001 84.6113Z"
            fill="#00A389"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M94.8333 102.46L100.404 96.3321L104.088 98.6346C105.042 99.2306 106.285 99.0616 107.045 98.2326L113.816 90.8456C114.314 90.3028 114.277 89.4594 113.734 88.9618C113.191 88.4642 112.348 88.5009 111.85 89.0437L105.266 96.2263L101.581 93.9233C100.625 93.3253 99.3772 93.4976 98.6182 94.3324L94.8333 98.4959V102.46Z"
            fill="#10A890"
          />
        </g>
        <circle cx="96.5" cy="89.5" r="145.5" fill="url(#paint0_radial_34826_92467)" />
      </g>
      <defs>
        <filter
          id="filter0_i_34826_92467"
          x="79.5"
          y="67.0443"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_92467" />
        </filter>
        <radialGradient
          id="paint0_radial_34826_92467"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(96.5 89.5) rotate(90) scale(145.5)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.73" stopColor="white" />
        </radialGradient>
        <clipPath id="clip0_34826_92467">
          <rect width="203" height="173" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

export default TimelineEmptyIcon;
